import React, { createContext, useState } from 'react';
import './Quiz.module.scss';
import { useMediaQ } from 'utilities/useMediaQ';
import Nav from 'components/Layout/components/Nav';
import EducationalDirection from './components/Slides/EducationalDirection/EducationalDirection';
import SwitchDirection from './components/Slides/SwitchDirection/SwitchDirection';
import Teaching from './components/Slides/Teaching/Teaching';
import CertaintyOfChoice from './components/Slides/CertaintyOfChoice/CertaintyOfChoice';
import ContactInfo from './components/Slides/ContactInfo/ContactInfo';
import Results from './components/Slides/Results/Results';
import ExtraInformationModal from './components/Slides/components/ExtraInformationModal/ExtraInformationModal';
import Permission from './components/Slides/Permission/Permission';

export const QuizContext = createContext({});

export default function Quiz() {
    const [questionIndex, setQuestionIndex] = useState(1); // default is 1
    const [answers, setAnswers] = useState({
        question1: '', // vo, po, mbo, hbo, so
        question2: '', // hybrid, full-switch
        question3: '', // teacher, assistant, instructor
        question4: '', // yes, no
        question5: '', // certain, orienting
    });
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [description, setDescription] = useState('');

    const mobile = useMediaQ('max', 525);

    function getColorFromSlide() {
        if (mobile) {
            return '#ffffff';
        }
        switch (questionIndex) {
            case 1:
                return '#46469A';
            case 2:
                return '#9E7FC9';
            case 3:
                return '#FAC15C';
            case 4:
                return '#35B6DD';
            case 5:
                return '#35B6DD';
            case 6:
                return '#9E7FC9';
            case 7:
                return '#9E7FC9';
            default:
                return '#9E7FC9';
        }
    }
    function getColorNameFromSlide() {
        if (mobile) {
            return 'purple';
        }
        switch (questionIndex) {
            case 1:
                return 'purple-dark';
            case 2:
                return 'purple';
            case 3:
                return 'yellow';
            case 4:
                return 'blue';
            case 5:
                return 'blue';
            case 6:
                return 'purple';
            case 7:
                return 'purple';
            default:
                return 'purple';
        }
    }

    const slideColor = getColorFromSlide();
    const slideColorName = getColorNameFromSlide();

    return (
        <>
            <QuizContext.Provider
                value={{
                    questionIndex,
                    setQuestionIndex,
                    answers,
                    setAnswers,
                    phone,
                    setPhone,
                    email,
                    setEmail,
                    getColorFromSlide,
                    firstName,
                    setFirstName,
                    lastName,
                    setLastName,
                    description,
                    setDescription,
                }}
            >
                <Nav color={slideColorName} />
                <div style={{ background: slideColor }} styleName="quiz">
                    {/* <div styleName="logo" onClick={() => history.push('/')}>
                        <img alt="logo" src="/images/rap-logos/logo-wit.svg" />
                    </div> */}
                    <div styleName="wrapper">
                        {(() => {
                            switch (questionIndex) {
                                case 1:
                                    return (
                                        <div styleName="inner ">
                                            <EducationalDirection />
                                        </div>
                                    );
                                case 2:
                                    return (
                                        <div styleName="inner ">
                                            <SwitchDirection />
                                        </div>
                                    );
                                case 3:
                                    return (
                                        <div styleName="inner ">
                                            <Teaching />
                                        </div>
                                    );
                                case 4:
                                    return (
                                        <div styleName="inner ">
                                            <Permission />
                                        </div>
                                    );
                                case 5:
                                    return (
                                        <div styleName="inner ">
                                            <CertaintyOfChoice />
                                        </div>
                                    );
                                case 6:
                                    return (
                                        <div styleName="inner ">
                                            <ContactInfo />
                                        </div>
                                    );
                                case 7:
                                    return <Results />;
                                default:
                            }
                        })()}
                    </div>
                </div>
            </QuizContext.Provider>
            <ExtraInformationModal color={slideColor} />
        </>
    );
}
